import React from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Field } from "redux-form";
import { renderCheckboxField } from "../../../../../utils/renderField";
import Show from "../../../../../utils/show.component";

export const RecurringDatePicker = (props) => {
  const shouldShowEndOfMonth = () => {
    const isEndOfMonth = props.endOfMonth;
    const frequency = props.frequency;

    const paymentDateMoment = moment(props.selected);
    const selectedDay = paymentDateMoment.format("DD");
    const lastDay = paymentDateMoment.endOf("month").format("DD");

    const shouldShow = selectedDay === lastDay && frequency === "Monthly";

    // Reset end of month if it becomes hidden, or if frequency is switched
    if (isEndOfMonth && (!shouldShow || frequency !== "Monthly")) {
      props.change("EndOfMonth", false);
    }

    return shouldShow;
  };

  return (
    <div>
      <div className="mb-1 bold f18">Select Payment Date</div>
      <div className="mb-4">Your payment will be made on this day.</div>
      <div className="mb-3">
        <button
          className="d-flex p-2"
          style={{ color: "white", backgroundColor: "#00558c", width: "240px" }}
          type="button"
          onClick={() => props.setCalendarOpen((state) => !state)}
        >
          <i className="material-icons pl-1 pr-5">calendar_month</i>
          {moment(props.paymentDate).format("ddd, M/D")}
        </button>
      </div>
      <Show condition={props.show}>
        <div className="mb-3">
          <DatePicker
            selected={props.selected}
            name="PaymentDate"
            id="PaymentDate"
            onChange={(date) => {
              props.change("PaymentDate", date);
              props.setCalendarOpen(false);
            }}
            minDate={moment().add(1, "d").toDate()}
            maxDate={moment().add(60, "d").toDate()}
            placeholderText="Select a date"
            data-e2e-id="paymentDatePicker"
            inline
          />
        </div>
      </Show>
      <Show condition={shouldShowEndOfMonth()}>
        <Field
          label="Pay on last day of each month"
          name="EndOfMonth"
          type="checkbox"
          id="EndOfMonth"
          component={renderCheckboxField}
        />
      </Show>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/authenticated-payments/payment-forms/field-components/recurring-fields/recurring-date-picker.component.js